import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { generatePath, useNavigate } from "../../../router-utils"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Box, Container } from "@sembark-travel/ui-base"
import { NewCustomerPaymentPreference } from "../../../CustomerPaymentPreferences"

export default function NewCustomerPaymentPreferencePage() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	function navigateBackOrToList() {
		if (backFromUrl) {
			return navigate(backFromUrl as "/org/customer-payment-preferences")
		}
		return navigate("/org/customer-payment-preferences")
	}
	return (
		<>
			<Helmet>
				<title>New Customer Payment Preferences</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<Breadcrumbs
					title="New Customer Payment Preference"
					items={[
						[
							generatePath("/org/customer-payment-preferences"),
							"Customer Payment Preferences",
						],
						["", "New"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="6xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<NewCustomerPaymentPreference
									onSuccess={navigateBackOrToList}
									onCancel={navigateBackOrToList}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
